import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable()
export class ValidatorService {
  getRowValidator(): FormGroup {
    return null;
  }
}
